import React from "react";
import { useParams, useLocation } from "react-router-dom";
import SavedSearchDetail from "./SavedSearchDetail";
import { readReviewEntry } from "../../hooks/useHomeEnrichmentReviewEntry";
import useSavedSearchVisit from "./useSavedSearchVisit";

/**
 * Remount SavedSearchDetail whenever the route id changes. React keeps the same
 * element type mounted across a param-only route change, so without the key a
 * saved search would inherit the previous one's rows, filters and scroll state.
 */
export default function WorkspaceDetailGate() {
  const { id } = useParams();
  const reviewingHistory = Boolean(readReviewEntry(useLocation().state));
  useSavedSearchVisit(reviewingHistory ? null : id);
  return <SavedSearchDetail key={id} />;
}
